import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'ar-i18n';


class CsvDownloadButton extends Component {

    /**
     * Component to show a link (disguised as a button to be consistent with UX design) to download a
     * CSV file of the data displayed in the dashboard. The CSV file is created client-side.
     */
    static propTypes = {
        columns: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                accessor: PropTypes.func.isRequired,
                render: PropTypes.func.isRequired
            })).isRequired,
        reportName: PropTypes.string.isRequired,
        reportItems: PropTypes.array
    };

    render() {
        let csvFile = new Blob(
            [
                '\ufeff', // Byte Order Mark that indicates programs to interpret it as Unicode
                this.getCsvReport()
            ],
            {type: 'text/csv'});
        return (
            <a
                className='hyperink-as-button'
                download={ this.props.reportName + '.csv' }
                href={ URL.createObjectURL(csvFile) }
            >
                { i18n.gettext('Download CSV') }
            </a>
        );
    }

    getCsvReport() {
        // First row contains the column labels
        let columns = this.props.columns;
        let rows = [
            '"' + _.map(columns, 'label').join('","') + '"'
        ];
        // Add one row per report item
        _.forEach(this.props.reportItems, function (item) {
            let row = _.map(columns, function (column) {
                let value = column.accessor(item);
                return column.render(value);
            });
            rows.push('"' + row.join('","') + '"');
        });
        return rows.join('\n');
    }

}

export default CsvDownloadButton;
